import { render, staticRenderFns } from "./RfqDetailMgn.vue?vue&type=template&id=49b26358"
import script from "./RfqDetailMgn.vue?vue&type=script&lang=js"
export * from "./RfqDetailMgn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports